<form [formGroup]="outboundLoadForm" (ngSubmit)="saveLoad()">
  <h1>{{ existingLoadId ? 'Edit' : 'Create' }} Outbound Load</h1>

  <p *ngIf="outboundLoadForm.disabled">
    <p-message severity="warn" [text]="closedWarning"></p-message>
  </p>

  <div class="p-grid">
    <div class="p-col p-lg-10 p-xl-8">
      <p-card header="Trailer Information">
        <div class="p-grid">
          <div class="form-group p-col p-lg-4 p-xl-5">
            <label>Load Status</label>
            <p-selectButton [options]="loadTypeOptions" formControlName="loadType" (onChange)="onChangeLoadType()"></p-selectButton>
          </div>
          <div class="form-group p-col p-lg-3 p-xl-4">
            <label class="required" for="siteSubinventoryId">Operation</label>
            <p-dropdown
              [options]="siteSubinventories"
              placeholder="-- Select Operation --"
              formControlName="siteSubinventoryId"
              inputId="siteSubinventoryId"
              [editable]="false">
            </p-dropdown>
            <error-block [field]="outboundLoadForm.controls.siteSubinventoryId" [messages]="{
              required: 'Operation is required.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-12 p-lg-6">
            <label class="required" for="loadShift">Shift Loaded</label>
            <app-worked-shift-selector
              formControlName="loadShiftId"
              [disabled]="outboundLoadForm.disabled"
              (dateSelected)="onLoadedShiftDateChanged($event)">
            </app-worked-shift-selector>
            <error-block [field]="outboundLoadForm.controls.loadShiftId" [messages]="{
              required: 'Shift Loaded is required.'
            }"></error-block>
            <error-block [field]="outboundLoadForm" [messages]="{
              shiftSequence: 'Loaded shift Must be before Shipped shift.'
            }"></error-block>
          </div>
          <div class="form-group p-col-12 p-lg-6">
            <label class="required" for="loadTime">Date/Time Loaded</label>
            <div class="p-inputgroup">
              <p-calendar inputId="loadDate" formControlName="loadDate" [showIcon]="true"></p-calendar>
              <time-entry inputId="loadTime" formControlName="loadTime" [timezone]="siteTimezone" [displaySeconds]="false"></time-entry>
            </div>
            <error-block [field]="outboundLoadForm.controls.loadDate" [messages]="{
              required: 'Date Loaded is required.'
            }"></error-block>
            <error-block [field]="outboundLoadForm.controls.loadTime" [messages]="{
              required: 'Time Loaded is required.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col p-lg-3 p-xl-4">
            <label>Propak BOL Number</label>
            <p class="form-field-static">{{outboundLoadForm.controls.propakBOLNum.value}}</p>
          </div>
          <div class="form-group p-col p-lg-3 p-xl-4">
            <label for="sealNumber">Seal Number</label>
            <input pInputText type="text" id="sealNumber" formControlName="sealNumber" />
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6 p-lg-4">
            <label class="required" for="carrier">Carrier</label>
            <div class="p-inputgroup">
              <p-dropdown [options]="carrierSelects" inputId="carrier" [filter]="true"
                  [editable]="false" [resetFilterOnHide]="true" placeholder="-- Select Carrier --" formControlName="carrierId"
                  [style]="{'width':'100%'}"></p-dropdown>
              <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddCarrier()"
                label="Add" [disabled]="outboundLoadForm.disabled"></button>
            </div>
            <app-add-carrier-form
              [(displayDialogFromForm)]="displayDialog"
              [carriers]="carriers"
              (update)="carrierSelectedChange($event)">
            </app-add-carrier-form>
            <error-block [field]="outboundLoadForm.controls.carrierId" [messages]="{
              required: 'Carrier is required.'
            }"></error-block>
          </div>
          <div class="form-group p-col-6 p-lg-4" *ngIf="showCarrierName">
            <label for="carrierName">Carrier Name</label>
            <input pInputText type="text" id="carrierName" formControlName="carrierName" />
            <error-block [field]="outboundLoadForm.controls.carrierName" [messages]="{
              requiredIfNosc: 'Carrier Name is required if the Carrier is &ldquo;No SCAC&rdquo;.'
            }"></error-block>
          </div>
          <div class="form-group p-col-12 p-lg-4">
            <label class="required" for="trailerNumber">Trailer</label>
            <app-trailer-select
              inputId="trailerId"
              name="trailerId"
              formControlName="trailerId"
              [eligibleFor]="trailerEligibleFor | async"
              [siteSubinventoryId]="selectedSubinventoryId | async"
              [carrier]="selectedCarrier | async">
            </app-trailer-select>
            <error-block [field]="outboundLoadForm.controls.trailerId" [messages]="{
              required: 'Trailer is required.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col">
            <label class="required" for="customer">Invoice To</label>
              <p-dropdown [options]="customersSelects | async" inputId="customer" [filter]="true" [editable]="false" [resetFilterOnHide]="true"
                placeholder="-- Select Customer --" formControlName="customerId" (onChange)="onChangeCustomer($event.value)"></p-dropdown>
              <error-block [field]="outboundLoadForm.controls.customerId" [messages]="{
                required: 'Customer is required.'
              }"></error-block>
          </div>
          <div class="form-group p-col">
            <label class="required" for="Pooler">Pooler</label>
              <p-dropdown [options]="poolersSelects | async" inputId="Pooler" [filter]="true" [editable]="false" [resetFilterOnHide]="true"
                placeholder="-- Select Pooler --" formControlName="poolerId"></p-dropdown>
                <!-- <error-block [field]="poolerId" [messages]="{
                  required: 'Pooler is required.'
                }"></error-block> -->
          </div>
          <div class="form-group p-col">
            <label [ngClass]="{'required':isShipped | async}">Ship To Location</label>
            <div class="p-inputgroup">
              <p-dropdown
                #poolerSelect
                formControlName="shipToLocation"
                [options]="poolerSitesSelects | async"
                [filter]="true"
                [editable]="false"
                [resetFilterOnHide]="true"
                (onFocus)="showDropdown($event)"
                (keydown.tab)="hideDropdown($event)"
                (keydown.shift.tab)="hideDropdown($event)"
                (onChange)="shipToLocationSelected()"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                appendTo="body"
                inputId="shipToLocation"
                placeholder="-- Select Ship To Location --">
                <ng-template pTemplate="item" let-item let-i>
                  <div [ngClass]="item.styleClass" [style]="{'min-height':'2em'}">{{item.label}}</div>
                </ng-template>
              </p-dropdown>
              <button *ngIf="!outboundLoadForm.controls.shipToLocation.value"
                  pButton type="button"
                  icon="pi pi-plus"
                  label="Add Ship To"
                  (click)="showDialogToAddShipTo()"
                  [disabled]="outboundLoadForm.disabled">
              </button>
              <button *ngIf="outboundLoadForm.controls.shipToLocation.value"
                      pButton type="button"
                      icon="pi pi-pencil"
                      (click)="showDialogToAddShipTo()"
                      [disabled]="outboundLoadForm.disabled">
              </button>
            </div>
            <error-block [field]="outboundLoadForm.controls.shipToLocation" [messages]="{
              required: 'Ship To Location is required.',
              requiredIf: 'Ship To Location is required',
              noAddress: 'Ship To Location has no address.'
            }"></error-block>
            <label class="address-subtext">{{getShipToAddress()}}</label>
            <app-add-shipped-to-form
              [(showDialog)]="displayAddShipToDialog"
              [makeGlidRequired]="cfGlidRequired"
              [customer]="selectedPooler | async"
              [poolerName]="poolerName | async"
              [updateOf]="getPoolerSite()"
              [siteId]="context?.site?.id"
              (update)="customerSiteChanged($event)">
            </app-add-shipped-to-form>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6 p-lg-3 p-xl-4">
            <label for="customerReferenceNumber" [ngClass]="{'required':customerReferenceRequired}">Customer Reference Number</label>
            <input type="text" pInputText id="customerReferenceNumber" formControlName="customerReferenceNumber"/>
            <error-block [field]="outboundLoadForm.controls.customerReferenceNumber" [messages]="{
              required: 'Reference # is required.',
              numberInUse: 'Reference # is already in use.',
              pattern: 'Reference # must be alpha-numeric',
              containsSpaces: 'Reference # must not have any leading or trailing spaces.'
            }"></error-block>
          </div>
          <div class="form-group p-col-6 p-lg-3 p-xl-4">
            <label for="altReferenceNumber">Alt Reference Number</label>
            <input type="text" pInputText id="altReferenceNumber" formControlName="altReferenceNumber"/>
            <error-block [field]="outboundLoadForm.controls.altReferenceNumber" [messages]="{
            pattern: 'Reference # must be alpha-numeric',
            containsSpaces: 'Reference # must not have any leading or trailing spaces.'
          }"></error-block>
          </div>
          <div *ngIf="tpmSelected()" class="p-col-6 p-lg-3 p-xl-2">
            <label for="isReuse">Reuse Load</label>
            <p-checkbox name="isReuse" inputId="isReuse" formControlName="isReuse"
                        [binary]="true" (onChange)="onChangeReuse()">
            </p-checkbox>
          </div>
        </div>
      </p-card>
      <p-card header="Scheduling Information">
        <div *ngIf="loadedNotificationTS">
          <p-message  severity="info" closeable="false" [text]="'Loaded Notifcation sent ' + (loadedNotificationTS | dateTimeToFormat: 'MM/dd/yyyy HH:mm z')"></p-message>
          <p-checkbox class="ml" value="false" label="Resend Notification" id="resendNotification" name="resendNotification" formControlName="resendNotification" [binary]="true"></p-checkbox>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-12 p-xl-6">
            <label for="customerNeededDate">Notification Date/Time</label>
            <div class="p-inputgroup">
              <p-calendar inputId="customerNeededDate" [showIcon]="true" formControlName="customerNeededDate"></p-calendar>
              <time-entry formControlName="customerNeededTime" [timezone]="siteTimezone"></time-entry>
            </div>
          </div>
          <div class="form-group p-col-12 p-xl-6">
            <label for="scheduledPickupDate">Scheduled Pickup Date/Time</label>
            <div class="p-inputgroup">
              <p-calendar inputId="scheduledPickupDate" [showIcon]="true" formControlName="scheduledPickupDate"></p-calendar>
              <time-entry formControlName="scheduledPickupTime" [timezone]="siteTimezone"></time-entry>
            </div>
          </div>
        </div>
        <div class="p-grid" *ngIf="isShipped | async">
          <div class="form-group p-col-12 p-lg-6">
            <label class="required" for="shippedShift">Shipped Date/Shift</label>
            <app-worked-shift-selector
              formControlName="shippedShiftId"
              (dateSelected)="onShippedShiftDateChanged($event)"
              [disabled]="outboundLoadForm.disabled">
            </app-worked-shift-selector>
            <error-block [field]="outboundLoadForm.controls.shippedShiftId" [messages]="{
              required: 'Shipped Shift is required.'
            }"></error-block>
            <error-block [field]="outboundLoadForm" [messages]="{
              shiftSequence: 'Loaded shift Must be before Shipped shift.'
            }"></error-block>
          </div>
          <div class="form-group p-col-12 p-lg-6">
            <label for="timeShipped" class="required">Time Shipped</label>
            <div class="p-inputgroup">
              <p-calendar inputId="dateShipped" formControlName="dateShipped" [showIcon]="true"></p-calendar>
              <time-entry inputId="timeShipped" formControlName="timeShipped" [timezone]="siteTimezone" [displaySeconds]="false"></time-entry>
            </div>
            <error-block [field]="outboundLoadForm.controls.dateShipped" [messages]="{
              required: 'Date Shipped is required.'
            }"></error-block>
            <error-block [field]="outboundLoadForm.controls.timeShipped" [messages]="{
              required: 'Time Shipped is required.'
            }"></error-block>
          </div>
        </div>
      </p-card>
      <p-card header="Outbound Load Line Items">
        <div class="p-grid">
          <p-table [value]="outboundLoadLineItems" dataKey="id" [paginator]="true" [rows]="10">
            <ng-template pTemplate="header">
              <tr>
                <th class="p-col-5">Product</th>
                <th class="p-col-5">Quantity</th>
                <th class="p-col-1">Underload</th>
                <th class="p-col-2">Delete</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
              <tr>
                <td>
                  <p-dropdown [options]="createLineItemProductSelects(rowData) | async" [(ngModel)]="rowData.productId" appendTo="body" (ngModelChange)="checkValue($event)"
                    [ngModelOptions]="{standalone: true}" name="products" #products="ngModel" [editable]="false" [filter]="true" [resetFilterOnHide]="true" [disabled]="outboundLoadForm.disabled"
                    (onChange)="onChangeOutboundLoadField(rowData)" (onHide)="handleProductHide(ri)">
                  </p-dropdown>
                </td>
                <td>
                  <input pInputText type="text" [(ngModel)]="rowData.quantity" [ngModelOptions]="{standalone: true}" name="quantity"
                    #quantity="ngModel" required lib-numeric [disabled]="outboundLoadForm.disabled"
                    (keydown.tab)="onChangeOutboundLoadField(rowData)" (blur)="onChangeOutboundLoadField(rowData)">
                </td>
                <td>
                  <p-checkbox [disabled]="outboundLoadForm.disabled" name="isUnderload" #isUnderload [(ngModel)]="rowData.isUnderload"
                    [ngModelOptions]="{standalone: true}" [binary]="true" (onChange)="onChangeOutboundLoadField(rowData)">
                  </p-checkbox>
                </td>
                <td>
                  <confirmation-button [iconsOnly]="true" actionIcon="pi pi-times" actionText="Delete"
                      confirmIcon="pi pi-times" confirmText="Delete" cancelIcon="pi pi-minus-circle"
                      cancelText="Cancel" (actionConfirmed)="onOutboundLoadRowCancel(rowData)" [disabled]="outboundLoadForm.disabled">
                  </confirmation-button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="4" class="centered">
                  No data available
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer" let-rowData>
              <tr [formGroup]="outboundLoadLineForm">
                <td>
                  <p-dropdown #productSelect [options]="productSelects | async" placeholder="-- Select Product --"
                              inputId="productID" class="form-control" name="product" formControlName="productId" appendTo="body" [readonly]="(productSelects | async)?.length == 0"
                              (onChange)="onChangeProduct($event)" (onHide)="handleProductHide()" [filter]="true" [editable]="false" [resetFilterOnHide]="true">
                </p-dropdown>
                <error-block [field]="outboundLoadLineForm.get('productId')" [messages]="{
                    required: 'Product is required.'
                  }">
                </error-block>
                </td>
                <td>
                  <input type="text" lib-numeric pInputText id="quantity" required name="quantity" class="form-control" formControlName="quantity"/>
                  <error-block [field]="outboundLoadLineForm.get('quantity')" [messages]="validateQuantityMessage()">
                  </error-block>
                </td>
                <td>
                  <p-checkbox id="isUnderload" name="isUnderload" formControlName="isUnderload" [binary]="true">
                  </p-checkbox>
                </td>
                <td>
                  <button type="button" pButton icon="pi pi-plus" iconPos="left" (click)="saveOLLI();" label="Add"
                    [ngClass]="{ 'p-state-disabled': !outboundLoadLineForm.valid }" [disabled]="outboundLoadForm.disabled"></button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="centered">
                  <label>
                    <b>Total Quantity: {{getTotal()}}</b>
                  </label>
                </td>
                <td></td>
                <td></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <error-block [field]="outboundLoadForm" [messages]="{
          lineItemsExist: 'Load must have one or more line items.'
        }"></error-block>
      </p-card>
      <p-card *ngIf="isShipped | async"  header="Load Rejection">
        <div class="p-grid">
          <div class="form-group p-col-2">
            <label for="isRejected">Rejected</label>
            <p-checkbox name="isRejected" inputId="isRejected" [binary]="true"
                        formControlName="isRejected" (onChange)="outboundLoadForm.controls.rejectionReason.reset();" class="isRejected"></p-checkbox>
          </div>
          <div class="form-group p-col-5" *ngIf="outboundLoadForm.get('isRejected')?.value">
            <label for="rejectionReason">Rejected Reason</label>
            <input type="text" pInputText id="rejectionReason" formControlName="rejectionReason" />
          </div>
        </div>
      </p-card>
      <p-card>
        <div class="p-grid">
          <div class="form group p-col-12 p-lg-6">
            <label for="comments">Comments</label>
            <div>
              <textarea pInputTextarea class="form-control textarea" formControlName="comments" id="comments" maxlength="255"></textarea>
            </div>
          </div>
          <div class="form group p-col-12 p-lg-6">
            <blob-storage
              label="Outbound Documents"
              [fileTypes]="['Outbound Load']"
              [entityId]="existingLoadId"
              entityParent="OutboundLoads"
              [documentIds]="documents"
              [siteId]="context?.site?.id">
            </blob-storage>
          </div>
        </div>
      </p-card>
      <p-card header="Exceptions" *ngIf="isShipped | async">
        <div class="p-grid">
          <div class="p-col p-lg-10 p-xl-7">
            <p-table [value]="exceptionItems" dataKey="id" editMode="row" [paginator]="true" [rows]="10">
              <ng-template pTemplate="header">
                <tr>
                  <th>Exception</th>
                  <th>Description</th>
                  <th class="deleteTh">Delete</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
                <tr>
                  <td>
                    <p-dropdown [options]="ExceptionTypes | enumSelect" [(ngModel)]="rowData.outboundLoadExceptionType" appendTo="body"
                                [ngModelOptions]="{standalone: true}" name="outboundLoadExceptionType" #outboundLoadExceptionType="ngModel" [required] (onChange)="onChangeExceptionField(rowData)"
                                [editable]="false" [filter]="true" [resetFilterOnHide]="true" [disabled]="outboundLoadForm.disabled">
                    </p-dropdown>
                  </td>
                  <td>
                    <input pInputText type="text" [(ngModel)]="rowData.description"
                           [ngModelOptions]="{standalone: true}" name="description"
                           #description="ngModel" required (keydown.tab)="onChangeExceptionField(rowData)"
                           (blur)="onChangeExceptionField(rowData)" [disabled]="outboundLoadForm.disabled">
                  </td>
                  <td>
                    <confirmation-button [iconsOnly]="true" actionIcon="pi pi-times" actionText="Delete"
                                         confirmIcon="pi pi-times" confirmText="Delete" cancelIcon="pi pi-minus-circle"
                                         cancelText="Cancel" (actionConfirmed)="onExceptionRowCancel(rowData)"
                                         [disabled]="outboundLoadForm.disabled">
                    </confirmation-button>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="3" class="centered">
                    No data available
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer" let-rowData>
                <tr [formGroup]="exceptionForm">
                  <td>
                    <p-dropdown [options]="ExceptionTypes | enumSelect" id="outboundLoadExceptionType" inputId="outboundLoadExceptionType" [editable]="false" class="form-control"
                                [required] placeholder="-- Select Exception --" name="outboundLoadExceptionType" formControlName="outboundLoadExceptionType" appendTo="body">
                    </p-dropdown>
                    <error-block [field]="exceptionForm.get('outboundLoadExceptionType')" [messages]="{
                      required: 'Exception is required.'
                    }">
                    </error-block>
                  </td>
                  <td>
                    <input type="text" pInputText id="description" required name="description" class="form-control" formControlName="description"/>
                    <error-block [field]="exceptionForm.get('description')" [messages]="{
                      required: 'Description is required.'
                    }">
                    </error-block>
                  </td>
                  <td>
                    <button type="button" pButton icon="pi pi-plus" iconPos="left" (click)="saveEI();" label="Add" [ngClass]="{ 'p-state-disabled': !exceptionForm.valid }" [disabled]="outboundLoadForm.disabled"></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-card>
      <p-card>
        <div class="form-buttons">
          <button pButton
            type="button"
            icon="pi pi-times-circle"
            (click)="resetOutboundLoadAutoSave()"
            class="p-button-info"
            [disabled]="outboundLoadForm.disabled"
            *ngIf="!existingLoadId"
            label="Reset Autosave">
          </button>
          <button pButton
            label="{{ existingLoadId ? 'Update' : 'Create' }} Load"
            icon="pi pi-plus"
            type="submit"
            [disabled]="outboundLoadForm.disabled || saving"
            [ngClass]="{'p-button-success ml' : true, 'p-state-disabled ml' : !outboundLoadForm.valid}">
          </button>
          <button pButton
            label="{{ existingLoadId ? 'Update' : 'Create' }} and Print BOL"
            icon="pi pi-plus"
            type="submit"
            (click)="saveLoad(true); $event.preventDefault();"
            [disabled]="outboundLoadForm.disabled || saving"
            [ngClass]="{'p-button-secondary ml' : true, 'p-state-disabled ml' : !outboundLoadForm.valid}">
          </button>
        </div>
      </p-card>
    </div>
  </div>

</form>
